import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_DOCUMENT_TITLE, ROUTE_TITLE_MAP } from '../constants/documentTitle.constants';

/**
 * Renderless component that updates `document.title` whenever the route changes.
 * Matches the current pathname against `ROUTE_TITLE_MAP` (first match wins),
 * falling back to `DEFAULT_DOCUMENT_TITLE` when no segment matches.
 *
 * @returns null — renders no DOM output.
 */
const DocumentTitle: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const match = ROUTE_TITLE_MAP.find(({ segment }) =>
      location.pathname.includes(segment),
    );
    document.title = match ? match.title : DEFAULT_DOCUMENT_TITLE;
  }, [location.pathname]);

  return null;
};

export default DocumentTitle;
